﻿import {useEffect, useMemo, useState} from "react";
import {getByIpLocation} from "../../components/location/requests/location-requests";
import {useLocationSearchParams} from "./useLocationSearchParams";
import {useGeocodeByLatLng} from "../maps/useGeocodeByLatLng";

export const useGeocodedPlaceByIpLatLng = ({currentPlace, shouldTryGeocodeByIp}: { currentPlace: any, shouldTryGeocodeByIp: boolean}) => {
    const [failedToGetByIp, setFailedToGetByIp] = useState<boolean>(false);
    const [currentLocationParams] = useLocationSearchParams();
    const [latitude, setLatitude] = useState<any>();
    const [longitude, setLongitude] = useState<any>();
    const {geocodedPlace, geocodingError} = useGeocodeByLatLng({latitude, longitude});

    const geocodingFailedOrLocationFailed = useMemo(() => {
        return failedToGetByIp || geocodingError
    }, [failedToGetByIp, geocodingError]);

    // reset failure if params change
    useEffect(() => {
        if (currentLocationParams) {
            setFailedToGetByIp(false);
        }
    }, [currentLocationParams]);

    // if failed to get by location, try using ip
    useEffect(() => {
        // might need to check currentPlace loading status
        if (shouldTryGeocodeByIp && (!currentLocationParams?.city || !currentLocationParams?.state) && !currentPlace) {
            getByIpLocation().then(({body}) => {
                if (body && body.ip && body.latitude && body.longitude) {
                    setLatitude(body.latitude);
                    setLongitude(body.longitude);
                } else {
                    setFailedToGetByIp(true);
                }
            }).catch(error => {
                console.error('searchByIp Error:', error);
                setFailedToGetByIp(true);
            })
        }
    }, [currentLocationParams, currentPlace, shouldTryGeocodeByIp]);

    return {
        geocodedPlaceByIpLatLng: geocodedPlace,
        failedToGetByIp: geocodingFailedOrLocationFailed
    }
}
